import { getLocateText, oddsKeyArray } from '../oddsKeyArray'
const locateKeyArray = [
  'champion',
  'runner_up',
  'third_place',
  'fourth_place',
  'the_fifth_place',
  'sixth_place',
  'seventh_place',
  'eight_place',
  'ninth_place',
  'tenth_place'
]

const initDesignated = () => {
  const mainKey = 'designated'

  const keyObj = {}

  locateKeyArray.forEach((supKey, index) => {
    for (let j = 1; j <= 10; j++) {
      const groupKey = getLocateText(j, index + 1)
      keyObj[groupKey] = {
        mainKey,
        supKey,
        groupKey
      }
    }
  })

  return keyObj
}

const initTwoSide = () => {
  const mainKey = 'two_side'

  return oddsKeyArray.reduce((root, oddsKey) => {
    locateKeyArray.forEach((supKey, index) => {
      const numIndex = index + 1

      if (numIndex <= 5) {
        root[`${numIndex}:${11 - numIndex}:DRAGON`] = {
          mainKey,
          supKey,
          groupKey: `${numIndex}:${11 - numIndex}:DRAGON`
        }
        root[`${numIndex}:${11 - numIndex}:TIGER`] = {
          mainKey,
          supKey,
          groupKey: `${numIndex}:${11 - numIndex}:TIGER`
        }
      }
      root[`${numIndex}:${oddsKey}`] = {
        mainKey,
        supKey,
        groupKey: `${numIndex}:${oddsKey}`
      }
    })

    return root
  }, {})
}

const initTopSum = () => {
  const mainKey = 'top_sum'
  const keyObj = {}
  let groupKey = ''

  for (const oddsKey of oddsKeyArray) {
    groupKey = `TOP:2:SUM:${oddsKey}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'big_small_odd_even',
      groupKey
    }
  }

  for (let i = 3; i <= 19; i++) {
    groupKey = `TOP:2:SUM:${i}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'sum_of_value',
      groupKey
    }
  }

  return keyObj
}

export default {
  ...initDesignated(),
  ...initTwoSide(),
  ...initTopSum()
}
